import Swiper, {Lazy} from "swiper";
import {LG_WIDTH, MD_WIDTH} from "@main/helpers/const.js";

class NewsSlider {
    constructor(el) {
        this.el = el;
        this.mySwiper;
        this.images = this.el.querySelectorAll(".js-news-img");
        this.init();
    }

    init() {
        const breakpoint = window.matchMedia(`(min-width:${LG_WIDTH}px)`);
        this.substituteSrcForImage();
        this.breakpointChecker(breakpoint);        
        breakpoint.addEventListener("change", () => this.breakpointChecker(breakpoint));
    }

    enable() {
        this.mySwiper = new Swiper(this.el, {
            modules: [Lazy],
            slidesPerView: "auto",
            spaceBetween: 8,
            preloadImages: false,
            watchSlidesProgress: true,
            breakpoints: {
                [MD_WIDTH]: {
                    spaceBetween: 16,
                    lazy: {
                        loadPrevNext: true,
                        loadPrevNextAmount: 3,
                    },
                },
            },
        });
    }

    breakpointChecker(breakpoint) {
        if (breakpoint.matches) {
            if (this.mySwiper !== undefined) {
                this.mySwiper.destroy(true, true);
            }
        } else {
            this.enable();
        }
    }

    substituteSrcForImage() {
        this.images.forEach((img) => {
            img.src = img.dataset.img;
        });
    }
}

window.addEventListener("load", function() {
    document.querySelectorAll(".js-news-slider").forEach((slider) => new NewsSlider(slider));
});
